export default function ({chosenQuoteId, chosenAddons, email, phone, firstName, lastName, city, street, postalCode}) {
  const contact = {
    email,
    firstName,
    lastName,
    street,
    phone,
    city,
    zip: postalCode
  }
  
  const addons = chosenAddons || []

  return {
    query: `mutation confirmSaleOrder (
        $contact: ConfirmSaleOrderContact, 
        $addons: [Addon], 
        $saleOrderAccessToken: String!
        $approvedDirectDebit: Boolean
        $confirmedResidentAndApprover: Boolean
      ) {
        confirmSaleOrder(
          contact: $contact, 
          addons: $addons, 
          saleOrderAccessToken: $saleOrderAccessToken
          approvedDirectDebit: $approvedDirectDebit
          confirmedResidentAndApprover: $confirmedResidentAndApprover
        ) {
        result
        }
      }`,
    variables: {
      contact,
      addons,
      saleOrderAccessToken: chosenQuoteId,
      // Todo: Remove the keys below from Odoo schema. These keys were not in the requirements but dynapps decided to add them anyway
      approvedDirectDebit: true,
      confirmedResidentAndApprover: true
    }
  }
}





